/**
 * Gets a normalized status value (In Queue, Running, Complete, Failed)
 * @param {String} statusValue - The status value from the API.
 * @param {Boolean} isFinished - Indicates if the process should be considered finished. (default false)
 * @returns {String} - The normalized status value.
 */
export function normalizeStatus(statusValue, isFinished = false) {
  if (!statusValue) return 'N/A';

  const loweredStatusValue = statusValue.toLowerCase();

  if (/queue/gi.test(loweredStatusValue)) return 'In Queue';
  if (/(success|complete)/gi.test(loweredStatusValue)) return 'Complete';

  // Consider the process to be running, if not finished.
  if (!isFinished) return 'Running';

  // Consider any other outcome as failed, if finished.
  if (isFinished) return 'Failed';

  return 'N/A';
}
